import { render, staticRenderFns } from "./no-version-group-alert.vue?vue&type=template&id=7045808c"
import script from "./no-version-group-alert.ts?vue&type=script&lang=ts&external"
export * from "./no-version-group-alert.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports